import * as React from "react"

// The markdown parser is the heaviest dependency in the app and only chat replies need
// it, so it is fetched on first use rather than shipped with every page.
const MarkdownRenderer = React.lazy(() => import("./markdown-renderer"))

/**
 * Renders model output as GitHub-flavoured markdown.
 *
 * Memoized because the chat re-renders on every streamed delta, and re-parsing every
 * earlier message each time would grow with the length of the conversation.
 */
export const Markdown = React.memo(function Markdown({ text }: { text: string }) {
  return (
    <div className="markdown">
      {/* Plain text until the parser arrives, so a reply never renders blank. */}
      <React.Suspense fallback={<p className="whitespace-pre-wrap">{text}</p>}>
        <MarkdownRenderer text={text} />
      </React.Suspense>
    </div>
  )
})
